module.exports = __webpack_public_path__ + "img/caas4.d19cde73.webp";